import { render, staticRenderFns } from "./zdgl.vue?vue&type=template&id=299a754f&scoped=true"
import script from "./zdgl.vue?vue&type=script&lang=js"
export * from "./zdgl.vue?vue&type=script&lang=js"
import style0 from "./zdgl.vue?vue&type=style&index=0&id=299a754f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299a754f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('299a754f')) {
      api.createRecord('299a754f', component.options)
    } else {
      api.reload('299a754f', component.options)
    }
    module.hot.accept("./zdgl.vue?vue&type=template&id=299a754f&scoped=true", function () {
      api.rerender('299a754f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sysConfig/zdgl.vue"
export default component.exports